// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"az_IB","skinnyRecommendations":"az_JB"};